// extracted by mini-css-extract-plugin
module.exports = {"root":"CJHnGvHn","wrapper":"_3dXBclF8","container":"_3xraTjHu","main":"s2vsxu6t","aside":"_2EFZyqxb","title":"_19voVnXf","additionalInformation":"nkhL1dca"};